<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'dashboard.query.overduechargeinformation.chargetypeid' | translate }}</label>
    <input type="number" appInput formControlName="chargeTypeId" readonly>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'dashboard.query.overduechargeinformation.chargetype' | translate }}</label>
    <select appSelect [collection]="chargeTypeList" formControlName="chargeType">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'dashboard.query.overduechargeinformation.owner' | translate }}</label>
    <select appSelect [collection]="chargeOwnerEnergyPartyList" formControlName="owner">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'dashboard.query.overduechargeinformation.start' | translate }}</label>
    <input type="date" appInput formControlName="start">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'dashboard.query.overduechargeinformation.start' | translate }}</label>
    <input type="date" appInput formControlName="end">
  </app-input-group>
</form>
